import { StockTicker } from "./StockTicker";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { VerifyBanner } from "./VerifyBanner";
import UnsubscribedPopup from "./UnsubscribedPopup";

export function Layout({ children }) {
    return (
        <div className="App">
            <StockTicker />
            <Navbar />
            <VerifyBanner />
            <main className="flex-1">{children}</main>
            <Footer />
            <UnsubscribedPopup />
        </div>
    );
}
